import React from 'react';
import { Link } from 'gatsby';
import { Image } from '..';
// import { Pagination, StoriesListItem, StoriesListItem } from '.';
import './StoriesListItem.scss';

const StoriesListItem = (props) => {
  const {
    uid,
    data,
    siteMetadata,
  } = props;
  const {
    storyName,
    eventLocation,
    // category,
    feedImage,
    feedImageOrientation,
  } = data;
  const { storiesSlug } = siteMetadata;
  return (
    <div className="stories-list-item">
      <Link
        className="container"
        to={`/${storiesSlug}/${uid}/`}
        aria-label={`Read more about ${storyName.text}`}
      >
        <div className={`image-container ${feedImageOrientation ? ` ${feedImageOrientation.toLowerCase()}` : ''}`}>
          <div className="inner-image">
            <Image image={feedImage} className="interactive-image cover" />
          </div>
        </div>
        <div className="details-container">
          <div className="info-col">
            <h2 className="title">{storyName.text}</h2>
            <span className="event-location">{eventLocation.text}</span>
          </div>
          <div className="arrow-col">
            <svg className="icon" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
            </svg>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default StoriesListItem;
